import React from 'react';
import { CiPlay1 } from "react-icons/ci";
import { CiCircleInfo } from "react-icons/ci";

const VideoTitle = ({ title, overview }) => {
  return (
    <div className="absolute top-0 left-0 w-full h-full text-white p-6 sm:p-12 flex flex-col justify-center items-start z-10">
      <h1 className="text-2xl sm:text-3xl font-bold">{title}</h1>
      <p className="mt-4 text-sm sm:text-base sm:w-1/2">{overview}</p>
      <div className="flex flex-col sm:flex-row sm:space-x-4 mt-8">
        <button className="flex items-center px-6 py-2 bg-white text-black rounded-md hover:bg-opacity-80 text-sm sm:text-base mb-4 sm:mb-0">
          <CiPlay1 size="24px" />
          <span className="ml-1">Play</span>
        </button>
        <button className="flex items-center px-6 py-2 bg-gray-500 bg-opacity-50 text-black rounded-md text-sm sm:text-base">
          <CiCircleInfo size="24px" />
          <span className="ml-1">Watch more</span>
        </button>
      </div>
    </div>
  );
};

export default VideoTitle;
